import { Component, inject, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Catalog } from '../../../rewards/interfaces/search-catalog-response.interface';

@Component({
  selector: 'app-verified-shared-wishlist-modal',
  templateUrl: './verified-shared-wishlist.modal.component.html',
})
export class VerifiedSharedWishListModalComponent {
  private ngbActiveModal = inject(NgbActiveModal);
  private router = inject(Router);

  name = signal<string | null>(null);

  closeModal() {
    this.ngbActiveModal.close();
  }

}
